import { render, staticRenderFns } from "./PVIMarkets.vue?vue&type=template&id=3f877296&"
import script from "./PVIMarkets.vue?vue&type=script&lang=js&"
export * from "./PVIMarkets.vue?vue&type=script&lang=js&"
import style0 from "./PVIMarkets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/PVIMarkets.vue
// module id = null
// module chunks = 